<template>

    <nav id="menu" class="navbar navbar-default navbar-fixed-top">
      <div class="container">
        
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" @click="toggled=!toggled" >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" @click="goToLink('/')"><div class="logo"></div></a>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        
        <div class="collapse navbar-collapse" :class="{'in':toggled}" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav navbar-right">
            <li v-bind:class="[currentPage === '/' ? activeClass:'']"><a @click="goToLink('/')" >Home</a></li>
            <li v-bind:class="[currentPage === '/company' ? activeClass:'']"><a @click="goToLink('/company')" >Company</a></li>
            <li v-bind:class="[currentPage === '/services' ? activeClass:'']"><a @click="goToLink('/services')"  >Services</a></li>
            <li v-bind:class="[currentPage === '/careers' ? activeClass:'']"><a @click="goToLink('/careers')"  >Careers</a></li>
            <li v-bind:class="[currentPage === '/contact' ? activeClass:'']"><a @click="goToLink('/contact')"  >Contact</a></li>
          </ul>
        </div><!-- /.navbar-collapse -->
        
      </div><!-- /.container-fluid -->
    </nav>
</template>


<script>
export default {
  data(){
    return{
      toggled:false,
      activeClass: 'nav_active'
    }
  },
  methods:{
    goToLink(link){
      if (this.$route.path != link) {
      this.$router.push(link);}
      this.toggled = false;
    }
  },
  computed:{
    currentPage(){
      return this.$route.path
    }
  }
}
</script>

<style scoped>
a{
  cursor: pointer;
}
.logo{
  height: 64px;
    width: 250px;
    background-size: contain;
    margin-top: -22px;
    background-image: url(/img/logo.png);
    background-repeat: no-repeat;
  }
.nav_active a{
  color: #c90e18 !important;
  background-color: transparent;
  font-weight: 700;
  }
    
</style>